let loopAccountCounter = 0;
const customerSignupStageOptions = [
    {
        stage: 1,
        stageText: 'SIGNUP',
        subtitle: 'Signup',
    },
    {
        stage: 2,
        stageText: 'ADDITIONAL INFO',
        subtitle: 'Additional Information',
    },
    {
        stage: 3,
        stageText: 'REVIEW',
        subtitle: 'Review',
    },
];

const signupPart = {
    shipInfo: {
        locationId: 0,
        company: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        fax: '',
    },
    billInfo: {
        locationId: 0,
        company: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        fax: '',
        creditLimit: '500',
    },
    billInfoTemp: {
        company: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        fax: '',
        creditLimit: '500',
    },
    sameAsShippingAddress: false,
    accounts: [getAccountInfo()],
};

function getSignUpPart() {
    let signupPart = {
        shipInfo: {
            locationId: 0,
            company: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            fax: '',
        },
        billInfo: {
            locationId: 0,
            company: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            fax: '',
            creditLimit: '500',
        },
        billInfoTemp: {
            locationId: 0,
            company: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            fax: '',
            creditLimit: '500',
        },
        sameAsShippingAddress: false,
        accounts: [getAccountInfo()],
    };
    return signupPart;
}

function getAccountInfo() {
    let accountCreation = {
        key: loopAccountCounter,
        firstName: '',
        lastName: '',
        email: '',
        userName: '',
        userId: '',
        oldFirstName: '',
        oldLastName: '',
    };
    ++loopAccountCounter;
    return accountCreation;
}

const annualFreightSpendOptions: Array<any> = [
    { key: 1, text: 'Under $10,000' },
    { key: 2, text: '$10,001-$50,000' },
    { key: 3, text: '$50,000 - $200,000' },
    { key: 4, text: '$200,000 - $500,000' },
    { key: 5, text: '$500,000 - $1,000,000' },
    { key: 6, text: '$1,000,000 - $5,000,000' },
    { key: 7, text: '$5,000,000+' },
];

function getAddInfoPart() {
    let addInfoPart = {
        isVistedShippingLocation: '',
        howToReceiveOrders: '',
        isOnlyShippingLocation: '',
        additionalShippingAddress: '',
        isShipTruckloadShipment: '',
        whereYouShip: '',
        annualFreightSpend: '',
        numOfLTLShippmentsEachWeek: '',
        isContract3PLWarehouses: '',
        additionalShippingLocations: '',
        isContractDrayageService: '',
        additionalInformation: '',
    };
    return addInfoPart;
}

const customerSignupHeader = {
    headerTitle: 'CUSTOMER SIGNUP',
    currentStage: 1,
    stageOptions: customerSignupStageOptions,
};

function getCustomerSignup() {
    let customerSignup = {
        customerSignupHeader,
        customerSignupBody: {
            signupPart: getSignUpPart(),
            addInfoPart: getAddInfoPart(),
            annualFreightSpendOptions,
            showLoding: false,
            showLoadingBar: false,
        },
        createAccountError: 0,
        getAccountInfo,
        getSignUpPart,
        getAddInfoPart,
        loopAccountCounter,
    };

    return customerSignup;
}

export default getCustomerSignup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/customerSignup/state.ts